var _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 18,
    y2: 12,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 24,
    x2: 38,
    y2: 24,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 36,
    x2: 38,
    y2: 36,
    stroke: "#053915",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5101 6.48988C38.8569 5.83671 37.8018 5.83671 37.1486 6.48988L34 9.63852L30.8514 6.48988C30.1982 5.83671 29.1431 5.83671 28.4899 6.48988C27.8367 7.14306 27.8367 8.19819 28.4899 8.85136L31.6385 12L28.4899 15.1486C27.8367 15.8018 27.8367 16.8569 28.4899 17.5101C29.1431 18.1633 30.1982 18.1633 30.8514 17.5101L34 14.3615L37.1486 17.5101C37.8018 18.1633 38.8569 18.1633 39.5101 17.5101C40.1633 16.8569 40.1633 15.8018 39.5101 15.1486L36.3615 12L39.5101 8.85136C40.1633 8.19819 40.1633 7.14306 39.5101 6.48988Z",
    fill: "#053915"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.bcb0ed65aea4d56d11b1212eca913328.svg";
export { ForwardRef as ReactComponent };